import React from 'react'
import PartnerListComponent from '../Components/PartnerList/PartnerListComponent'

function PartnerPage() {
    return (

        <PartnerListComponent/>
    )
}

export default PartnerPage